export enum UserStatus {
  Inactive = 0,
  Active = 1,
  Archived = 2
}

export enum UserStatusColor {
  Inactive = '#FF4D4F',
  Active = '#23A566',
  Archived = '#FF9F29'
}

export enum UserRole {
  Admin = 1,
  User = 2,
  StandardAdmin = 3
}

export enum UserRoleColor {
  Admin = '#A461D8',
  User = '#EF1B81',
  StandardAdmin = '#572BD3'
}

export enum COLORS {
  GREEN = '#23A566',
  RED = '#FC5A5A'
}

export enum FormValidators {
  FirstName = 100,
  LastName = 100,
  Email = 100,
  ContactNumber = 100,
  SalesforceEmail = 100,
  UserCRMbccEmail = 100,
  SalesRepID = 80,
  Password = 100,
  PasswordMin = 8,
  CompanyRole = 100
}
